import Button from '@atlaskit/button/new';
import DropdownMenu, { DropdownItemGroup, DropdownItem } from '@atlaskit/dropdown-menu';
import ChevronDownIcon from '@atlaskit/icon/utility/migration/chevron-down';
import { Inline, Text } from '@atlaskit/primitives';
import {
  DatabaseFilterUsageType,
  DatabaseFilterType,
} from '@databases/types/database/view';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import useView from '../../hooks/useView';
import { messages } from '../../i18n';

const labels: Record<
  DatabaseFilterUsageType,
  { id: string; defaultMessage: string; description: string }
> = {
  [DatabaseFilterType.AND]: messages['view-settings-panel-filter.and-filter-type-label'],
  [DatabaseFilterType.OR]: messages['view-settings-panel-filter.or-filter-type-label'],
};

export interface ViewSettingsFilterUsagePickerProps {
  handleChangeFilterType: (type: DatabaseFilterUsageType) => void;
}

const ViewSettingsFilterUsagePicker: FunctionComponent<
  ViewSettingsFilterUsagePickerProps
> = ({ handleChangeFilterType }) => {
  const { view } = useView();
  const { formatMessage } = useIntl();
  const filterObject = view.settings.filter;

  return (
    <Inline alignBlock="center" space="space.050">
      <Text id="filter-type-label">
        {formatMessage(messages['view-settings-panel-filter.filter-type-description'])}
      </Text>
      <DropdownMenu
        testId="filter-type-dropdown-menu"
        trigger={({ triggerRef, ...props }) => (
          <Button
            ref={triggerRef as React.RefObject<HTMLButtonElement>}
            aria-labelledby="filter-type-label filter-type-value"
            iconAfter={() => <ChevronDownIcon LEGACY_size="medium" label="" />}
            {...props}
          >
            <span id="filter-type-value">
              {filterObject
                ? formatMessage(labels[filterObject?.type as DatabaseFilterUsageType])
                : ''}
            </span>
          </Button>
        )}
      >
        <DropdownItemGroup>
          {Object.entries(labels).map(([type, label]) => (
            <DropdownItem
              key={type}
              isSelected={filterObject?.type === type}
              onClick={() => {
                handleChangeFilterType(type as DatabaseFilterUsageType);
              }}
            >
              {formatMessage(label)}
            </DropdownItem>
          ))}
        </DropdownItemGroup>
      </DropdownMenu>
    </Inline>
  );
};

export default ViewSettingsFilterUsagePicker;
